<template lang="pug">
	.ssml--azure-neural-hd-settings.flex-col.space
		.flex-col
			.flex-row.justify
				.grey.upper.small-font {{$tCaption('Temperature')}}  {{$Data.formatNumber(parameters.temperature, '#0.0#')}}
				.helper
					fas(icon="circle-question", id="temperatureHelp")
					DxTooltip(target="#temperatureHelp", show-event="dxhoverstart", hide-event="dxhoverend", width="400")
						pre.pre-wrap.ssml--azure-neural-hd-settingss.tooltip-content {{temperatureDesc}}
			DxSlider(:value.sync="parameters.temperature", :min="0", :max="1", :show-spin-buttons="true", :step="0.01", :show-range="false")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxSlider from 'devextreme-vue/slider';
	import DxCheckBox from 'devextreme-vue/check-box';
	import { DxTooltip } from 'devextreme-vue/tooltip';
	import ssmlHelper from './ssml-helper';

	export default {
		translationCategory: 'insertion.SSMLAzureNeuralHDSettings',
		name: 'ssml--azure-neural-hd-settings',
		components: { DxButton,  DxSlider, DxCheckBox, DxTooltip },
		props: ['record'],
		data() {
			return {
				temperatureDesc: this.$tCaption(`Lower temperature results in less randomness, leading to more predictable outputs. Higher temperature increases randomness, allowing for more diverse outputs.`),
				parameters: {
					temperature: 1
				}
			};
		},
		computed: {
			settings() {
				return this.record.voiceSettings || {};
			}
		},
		watch: {
			parameters: {
				handler() {
					this.saveParameters();
				},
				deep: true
			}
		},
		mounted() {
			if (__DEBUG__)
				window.elevelLabsSettings = this;

			this.init();
		},
		methods: {
			init() {
				let ssml = ssmlHelper.prepareSsml(this.record.ssml || ' ', { ...this.record, sender: this })?.ssml;
				let parameters = ssmlHelper.processSsmlSetting(ssml, 'parameters')?.value || '';

				let params = parameters.split(';');

				params.map(pStr => {
					let pArr = pStr.split('=');
					let pName = pArr[0];
					let pValue = pArr[1];

					if (pName) {
						this.$set(this.parameters, pName, pValue);
					}
				});
			},
			saveParameters() {
				let ssml = ssmlHelper.prepareSsml(this.record.ssml || ' ', { ...this.record, sender: this })?.ssml;

				let parametersValue = Object.keys(this.parameters).map(pKey => `${pKey}=${JSON.stringify(this.parameters[pKey])}`).join(';');
				let processedSSML = ssmlHelper.processSsmlSetting(ssml, 'parameters', parametersValue)?.ssml || ssml;

				if (__DEBUG__)
					console.debug('AzureNeuralHD Settings', { processedSSML })

				this.$emit('ssml-changed', processedSSML);
			}
		}
	};
</script>
<style lang='scss'>
	.ssml--azure-neural-hd-settings {
		&.tooltip-content {
			text-align: left;
		}

		.helper {
			color: #c1c1c1;
		}
	}
</style>
